import React from 'react';
import { AnimatePresence } from 'framer-motion';
import { AnswerOptions, Main, QuestionText, VisualPicker } from './Question.styles';
import { animationVariants, ANSWER_OPTIONS } from './Question.meta';
import { useIsMobile } from '../../../../_hooks/useIsMobile';
import { Answers, CurrentQuestion } from '../../Survey.meta';
import { KeyboardShortcut } from '../../Survey.styles';
import { useKey } from '../../hooks/useKey';
import { CARD_ANIMATION } from '../../../BeFi20.meta';

interface Props {
  questions: string[];
  currentQuestion: CurrentQuestion;
  answers: Answers;
  onAnswer: (questionIndex: number, answer: number) => void;
}

export const Question = ({ questions, currentQuestion, answers, onAnswer }: Props) => {
  const isMobile = useIsMobile();

  ANSWER_OPTIONS.forEach(({ keyboardShortcut, value }) => {
    useKey(keyboardShortcut, () => onAnswer(currentQuestion.index, value));
  });

  return (
    <>
      <AnimatePresence custom={{ direction: currentQuestion.direction, isMobile }}>
        <Main
          key={currentQuestion.index}
          custom={{ direction: currentQuestion.direction, isMobile }}
          variants={animationVariants}
          initial="enter"
          animate="visible"
          exit="exit"
          transition={
            isMobile
              ? { duration: 0.28, ease: 'easeOut' }
              : { duration: CARD_ANIMATION.duration, ease: CARD_ANIMATION.easing }
          }
        >
          <QuestionText as="h1">{questions[currentQuestion.index]}</QuestionText>

          <AnswerOptions>
            {ANSWER_OPTIONS.map(option => (
              <VisualPicker
                key={option.value}
                onClick={() => onAnswer(currentQuestion.index, option.value)}
                aria-pressed={answers[currentQuestion.index] === option.value}
              >
                {option.label}

                <KeyboardShortcut>{option.keyboardShortcut}</KeyboardShortcut>
              </VisualPicker>
            ))}
          </AnswerOptions>
        </Main>
      </AnimatePresence>
    </>
  );
};
